import { Component, Input } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import 'rxjs/add/operator/first';

import { Tracker, User } from '../../../entities/index';
import { PushService } from '../../../services/push.service';
import { Log } from '../../../utils/index';

@Component({
  selector: 'app-push-notification',
  templateUrl: './push-notification.html'
})
export class PushNotificationComponent {
  @Input()
  tracker: Tracker;

  @Input()
  user: User;

  message: string;
  appli = true;
  mail = true;
  sms = false;

  constructor(protected pushService: PushService, protected notification: NotificationsService) {}

  clearForm() {
    this.message = null;
    this.appli = true;
    this.mail = true;
    this.sms = false;
  }

  @Log('blue')
  sendNotification() {
    let entity;
    let id;

    if (this.tracker) {
      entity = 'tracker';
      id = this.tracker.id;
    } else if (this.user) {
      entity = 'user';
      id = this.user.id;
    } else {
      this.notification.error('ERROR', 'No user or no tracker!');
      return;
    }

    this
      .pushService
      .send(entity, id, this.message, this.appli, this.mail, this.sms)
      .first()
      .subscribe(() => {
        this.notification.success('SUCCESS', 'The notification have been sent.');
        this.clearForm();
      });
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/components/blocks/push-notification/push-notification.component.ts